import { ONE_DEGREE_IN_RADIANS } from "../math/constants";

/**
 * Computes the distance the camera must be from an object to precisely frame
 * the given width and height. This assumes the camera looks directly at the
 * center of the rectangle given by width and height and that this rectangle
 * is orthogonal to the z-axis of the camera.
 *
 * @param vFov the vertical field of view in degrees
 * @param aspect the aspect ratio of the camera, i.e. width/height, so ~1.77
 * for a 16:9 frame.
 * @param width the width in scene units (inches) of the plane we want to frame
 * @param height the height in scene units (inches) of the plane we want to frame
 * @returns the distance the camera should be placed from the plane
 */
export const computeViewingDistance = (
    vFov: number, aspect: number, width: number, height: number): number =>
{
    const
        halfWidth = 0.5 * width,
        halfHeight = 0.5 * height,
        // half vertical FOV
        hvFov = 0.5 * vFov * ONE_DEGREE_IN_RADIANS,
        // half horizontal FOV
        hhFov = Math.atan(Math.tan(hvFov) * aspect);
    
    return Math.max(
            halfHeight / Math.tan(hvFov),
            halfWidth / Math.tan(hhFov)
        );
}
export default computeViewingDistance;
